import { useTranslation } from 'react-i18next';
import PricingCard from '../../components/settings/pricing-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/** Settings › Pricing & quotes › Rates & quote defaults: only this card, so only its reads run. */
export default function PricingBasePage() {
  const { t } = useTranslation();
  return (
    <SettingsLeafPage
      title={t('settings.pricingPages.tiles.base.title')}
      back={{ to: '/settings/pricing', label: t('settings.pricingPages.backToPricing') }}
    >
      <PricingCard />
    </SettingsLeafPage>
  );
}
